import PersonIcon from "@mui/icons-material/Person";
import { ErasmusServicePath, TEACHERS_OUTGOING_ERASMUS } from "utils/constants";
import { tenants } from "utils/tenants";
import permissions from "app/permissions";
import ListErasmusOutgoingTeachers from "./List";
import CreateErasmusOutgoingTeachers from "./Create";
import EditErasmusOutgoingTeachers from "./Edit";
import ShowErasmusOutgoingTeachers from "./Show";

export const resources = {
  isMenu: true,
  icon: <PersonIcon />,
  tenancies: [tenants.MU],
  name: `${ErasmusServicePath}${TEACHERS_OUTGOING_ERASMUS}`,
  title: "Заминаващи преподаватели",
  list: <ListErasmusOutgoingTeachers />,
  create: <CreateErasmusOutgoingTeachers />,
  edit: <EditErasmusOutgoingTeachers />,
  show: <ShowErasmusOutgoingTeachers />,
  permission: permissions.canPreviewErasmusOutgoingTeachers,
  createPermission: permissions.canManageErasmusOutgoingTeachers,
  editPermission: permissions.canManageErasmusOutgoingTeachers,
  showPermission: permissions.canPreviewErasmusOutgoingTeachers,
};
